import React, { createContext } from "react";
import { SimpleLoader, TertiaryButton, Typography } from "@dev/ee-components";
import { useTablet } from "@/services/hooks/useTablet";
import { WidgetProps } from "./types";
import { WidgetBox, WidgetBoxWrapper, WidgetButton, WidgetContent, WidgetTitle } from "./styles";
  
export const WidgetPropsContext = createContext<WidgetProps | undefined>(undefined);

export const Widget = (props: WidgetProps) => {
    const { title, content, isLoading, button, widgetIndex = 0, isButtonVisible } = props;
    const isTablet = useTablet();
    return (
        <WidgetPropsContext.Provider
            value={props}
        >
            <WidgetBoxWrapper $widgetIndex={isTablet ? -1 : widgetIndex}>
                <WidgetBox>
                    {
                        props.useCustomContentLayout ? content : 
                        <>
                            <WidgetTitle>
                                <Typography variant='h2'>
                                    {title}
                                </Typography>
                            </WidgetTitle>
                            <WidgetContent>
                                {!isLoading && content}
                                {isLoading && <SimpleLoader />}
                            </WidgetContent>
                            {isButtonVisible && 
                                <WidgetButton>
                                    <TertiaryButton text={button?.textKey} onClick={button?.onClick} disableSentenceCase />
                                </WidgetButton>
                            }
                        </>
                    }
                </WidgetBox>
            </WidgetBoxWrapper>
        </WidgetPropsContext.Provider>
    );
};
